import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { colors } from "~/utils/colors";

const { brand, white } = colors;

const useStyles = makeStyles((theme) => ({
	text: {
		textAlign: "center",
	},
	actions: {
		justifyContent: "center",
		padding: "0 16px 16px 16px",
	},
	confirmButton: {
		backgroundColor: brand?.default,
		margin: "4px",
		padding: "7px",
		color: white,
		height: 44,
		fontSize: "15px",
		display: "flex",
		width: "100%",
		borderRadius: "25.5px",
		flex: 1,
		cursor: "pointer",
		textTransform: "none",
		"&:active": {
			backgroundColor: brand?.dark,
			color: white,
		},
		"&:hover": {
			backgroundColor: brand?.dark,
			color: white,
		},
	},
}));

const BackendErrorDialog = ({ open, onClose, message, business, history }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const handleGoToReservations = () => {
		onClose();
		if (business?.id) {
			history.push(`/reservas/${business.id}`);
		} else {
			history.push(`/reservas`);
		}
	};

	return (
		<Dialog
			onClose={onClose}
			open={open}
			PaperProps={{
				style: { borderRadius: 30, maxHeight: 244, maxWidth: 312 },
			}}>
			<DialogTitle className={classes.text}>{t("Ocorreu um erro")}</DialogTitle>
			<DialogContent>
				<DialogContentText className={classes.text}>{message || t("An error occurred")}</DialogContentText>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button className={classes.confirmButton} onClick={handleGoToReservations}>
					{t("View my reservations")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BackendErrorDialog;

